import { Link, useSearchParams } from "react-router-dom";
import Footer from "../../components/layout/Footer";
import Header from "../../components/layout/Header";
import LoadingScreen from "../../components/loadingScreen";
import { useUserContext } from "../../hooks/useUserContext";
import StatusCard from "./components/statusCard";
import ShipmentCard from "./components/shipmentCard";
import NoShipmentCard from "./components/shipmentCard/noShipmentCard";
import ContactCard from "./components/contactCard";
import AddressDetailsCard from "./components/addressDetailCard";
import PartInformationCard from "./components/partInformationCard";
import OrderSummaryCard from "./components/orderSummaryCard";
import { routeEndpoints } from "../../routes/routeEndpoints";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { getOrderDetails } from "../../api/orderService";
import { useQuery } from "@tanstack/react-query";

export default function OrderDetailsPage() {
  const { isLoading } = useUserContext();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("id");

  const { data: order, isLoading: isOrderDetailsLoading } = useQuery({
    queryKey: ["order-details", orderId],
    queryFn: () => getOrderDetails(orderId!),
    enabled: !!orderId,
  });
  const address = order?.address;
  const shipments = order?.shipments;

  if (isLoading || isOrderDetailsLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#F9FAFB] font-sans">
      <Header />
      <main className="flex-1 px-4 md:px-12 lg:px-30 py-6 md:py-8">
        <div className="flex flex-col gap-5">
          <Link
            to={routeEndpoints.orders}
            className="flex w-fit items-center gap-2 text-sm text-blue-600 hover:text-blue-700 transition-colors"
          >
            <ArrowLeftIcon className="size-4" />
            Back to orders
          </Link>

          <div className="flex flex-col lg:flex-row lg:items-start gap-4">
            <div className="flex min-w-0 flex-1 flex-col gap-4">
              <StatusCard orderId={order.orderId} steps={order.steps} />
              {order.needsItem &&
                (shipments?.seller ? (
                  <ShipmentCard
                    title="Seller Shipment"
                    orderId={orderId!}
                    shipmentType="seller"
                    shipment={shipments.seller}
                  />
                ) : (
                  <NoShipmentCard title="Seller Shipment" />
                ))}

              {shipments?.customer ? (
                <ShipmentCard
                  title="Customer Shipment"
                  orderId={orderId!}
                  shipmentType="customer"
                  shipment={shipments.customer}
                />
              ) : (
                <NoShipmentCard title="Customer Shipment" />
              )}
              <PartInformationCard part={order.part} />
              <OrderSummaryCard summary={order.summary} />
            </div>

            <div className="flex flex-col gap-4 lg:w-80 xl:w-95 lg:shrink-0">
              <ContactCard contact={order.contact} />
              <AddressDetailsCard to={address.to} from={address.from} />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
